module.exports = __webpack_public_path__ + "static/media/pic1.af30f724.jpg";